import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
    locale: 'zh-cn', // localStorage.getItem('locale') || 'zh-cn', // 暂时不做多语言，先用中文的
    publicSideMenu: [],
  },
  mutations: {
    //
    SETLOCALE(state, locale) {
      localStorage.setItem('locale', locale);
      state.locale = locale;
    },
    SETPUBLICSIDEMENU(state, publicSideMenu) {
      state.publicSideMenu = publicSideMenu;
    }
  },
  getters: {
    getLocale: state => state.locale,
    getPublicSideMenu: state => state.publicSideMenu,
  },
  actions: {
    //
  },
  modules: {
    user,
    app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js